import { render, staticRenderFns } from "./sp-carousel-by-type.vue?vue&type=template&id=47aebe22"
import script from "./sp-carousel-by-type.vue?vue&type=script&lang=js"
export * from "./sp-carousel-by-type.vue?vue&type=script&lang=js"
import style0 from "./sp-carousel-by-type.vue?vue&type=style&index=0&id=47aebe22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
